/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Export_Success_ToastInputs */

const en_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset exported successfully`)
};

const fr_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset exporte avec succes`)
};

const de_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung erfolgreich exportiert`)
};

const it_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinito esportato correttamente`)
};

const ru_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные настройки успешно экспортированы.`)
};

const es_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste exportado exitosamente`)
};

const zh_cn2_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设已成功导出`)
};

const ja_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが正常にエクスポートされました`)
};

const hi_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सफलतापूर्वक निर्यात हो गया`)
};

const pt_pt2_preset_manager_export_success_toast = /** @type {(inputs: Preset_Manager_Export_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição exportada com sucesso.`)
};

/**
* | output |
* | --- |
* | "Preset exported successfully" |
*
* @param {Preset_Manager_Export_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_success_toast = /** @type {((inputs?: Preset_Manager_Export_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_export_success_toast(inputs)
	if (locale === "de") return de_preset_manager_export_success_toast(inputs)
	if (locale === "it") return it_preset_manager_export_success_toast(inputs)
	if (locale === "ru") return ru_preset_manager_export_success_toast(inputs)
	if (locale === "es") return es_preset_manager_export_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_export_success_toast(inputs)
	if (locale === "ja") return ja_preset_manager_export_success_toast(inputs)
	if (locale === "hi") return hi_preset_manager_export_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_export_success_toast(inputs)
	return en_preset_manager_export_success_toast(inputs)
});